import { ChevronDown, Loader2 } from "lucide-react";

export interface LoadMoreButtonProps {
  loadingMore: boolean;
  remaining: number;
  onLoadMore: () => void;
}

export function LoadMoreButton({ loadingMore, remaining, onLoadMore }: Readonly<LoadMoreButtonProps>) {
  const label = loadingMore ? "Loading..." : `Show more (${remaining} remaining)`;

  return (
    <div className="flex justify-center mt-4">
      <button
        type="button"
        onClick={onLoadMore}
        disabled={loadingMore}
        className="flex items-center gap-2 px-4 py-2 text-sm text-content-secondary hover:text-content-primary bg-surface-secondary hover:bg-interactive-hover border border-border-secondary rounded-lg transition-colors disabled:opacity-50"
      >
        {loadingMore ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ChevronDown className="h-3.5 w-3.5" />}
        {label}
      </button>
    </div>
  );
}
